'use strict';
var additionDispoHours = parseInt($('#additionalDispoHours').val());

export class StoreHours {
    run () {
        var daysOfTheWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        this.currentDate = new Date();
        this.today = daysOfTheWeek[this.currentDate.getDay()];
        this.tomorrow = daysOfTheWeek[this.currentDate.getDay() + 1] || daysOfTheWeek[0];
        this.storeHoursList = $('.js-store-hours-list li[data-name="' + this.today + '"]:not(.active)');

        this.init();
        this.addEventListeners();
    }

    init () {
        var _self = this;

        this.storeHoursList.each(function (_idx, storeHours) {
            $(storeHours).addClass('active');

            var currentStore = $(storeHours).parents('.js-store-hours');
            var nextPhase = _self.getStoreHoursPhase(storeHours, currentStore);

            var isBopis = $(storeHours).parents('.result').hasClass('is-bopis');
            var dispoArrival = isBopis ? _self.getDispoArrival(storeHours, currentStore) : null;
            var noDispoArrival = $('.shipping-method-selected .estimated-delivery-interval').html();

            // Check for temporarily closed store
            var isTemporarilyClosed = currentStore.data('temporarily-closed');
            var reopDate = currentStore.data('reopening-date') ? currentStore.data('reopening-date').split('-') : false; // Format: yyyy-mm-dd
            var reopeningDate = reopDate ? new Date(reopDate[0], (reopDate[1] - 1), reopDate[2]) : false;

            if (isTemporarilyClosed) {
                if (!reopeningDate) {
                    currentStore.find('.js-store-hours-temporarily-closed').removeClass('hidden');
                } else if (_self.currentDate < reopeningDate) {
                    currentStore.find('.js-store-hours-temporarily-closed').removeClass('hidden');
                    currentStore.find('.js-store-hours-reopens-on').removeClass('hidden');
                    nextPhase = reopeningDate.toLocaleDateString($('html').attr('lang'));
                } else {
                    isTemporarilyClosed = false;
                }
            }

            if (!isTemporarilyClosed) {
                if (_self.isStoreOpen(storeHours)) {
                    currentStore.find('.js-store-hours-open').removeClass('hidden');
                    currentStore.find('.js-store-hours-open-until').removeClass('hidden');
                } else {
                    currentStore.find('.js-store-hours-closed').removeClass('hidden');

                    if (nextPhase) {
                        currentStore.find('.js-store-hours-reopens-at').removeClass('hidden');
                    }
                }
            }

            currentStore.find('.js-store-next-phase').html(nextPhase);

            if (noDispoArrival) {
                currentStore.parent('.result').find('.js-store-dispo-info-collection').html(noDispoArrival.split('-')[0]);
            }
            currentStore.parent('.is-bopis').find('.js-store-dispo-info-collection').html(dispoArrival);
        });
    }

    addEventListeners () {
        // Toggle store hours list dropdown
        $('.js-toggle-store-hours').off('click').on('click', function (e) {
            e.preventDefault();
            $(this).find('.js-toggle-store-hours-dropdown').toggleClass('cc-storeHours-rotate');
            $(this).find('.toggle-store-hours-dropdown').toggleClass('cc-storeHours-rotate');
            $(this).closest('.js-store-hours').find('.js-store-hours-list').toggleClass('hidden');
        });
    }

    /**
     * Get next store hours phase to be appended to "open until" or "re-opens at"
     * @param {object} storeHours
     * @param {object} store
     * @returns {string} return next store hours phase
     */
    getStoreHoursPhase (storeHours, store) {
        var phases = $(storeHours).data('first-phase') ? $(storeHours).data('phases').split(' ; ') : false;
        var tomorrowFirstPhase = $('[data-store-id="' + store.data('store-id') + '"] li[data-name="' + this.tomorrow + '"]').data('first-phase');
        var currentPhase = -1;

        // Loop through x phases
        for (var i = 0; i < phases.length; i++) {
            var phase = phases[i].split('-'); // Split start and end time
            var startPhase = phase[0].split(':'); // Split hours and mins for

            var startDate = new Date(this.currentDate.getTime()); // Create Date object based on currentDate
            startDate.setHours(startPhase[0]); // Set hours and mins based on
            startDate.setMinutes(startPhase[1]);

            // Check if today occured a phase
            if (startDate <= this.currentDate) {
                currentPhase = i;
            }
        }

        var nextPhase;

        if (this.isStoreOpen(storeHours)) {
            // If store is open returns current phase end time
            nextPhase = phases[currentPhase].split('-')[1];
        } else if (currentPhase < phases.length - 1) {
            // Store closed, show next phase start time if available
            nextPhase = phases[currentPhase + 1].split('-')[0];
        } else if (tomorrowFirstPhase) {
            var tomorrowStartTime = tomorrowFirstPhase.split(':');
            if (phases || (this.currentDate.getHours() >= tomorrowStartTime[0] && this.currentDate.getMinutes() >= tomorrowStartTime[1])) {
                // End of phases show next day start time if available
                nextPhase = tomorrowFirstPhase;
            }
        } else {
            // End of phases and closed next day
            nextPhase = false;
        }

        return nextPhase || false;
    }

    /**
     * Check if store is open in a specific date
     * @param {object} storeHours
     * @returns {boolean} return next phase if open, otherwise false
     */
    isStoreOpen (storeHours) {
        var phases = $(storeHours).data('first-phase') ? $(storeHours).data('phases').split(' ; ') : false;
        var isStoreOpen = false;

        // Check if today has store hours
        if (!phases) {
            return false;
        }

        // Loop through x phases
        for (var i = 0; i < phases.length; i++) {
            // Split phases to start and end
            var phase = phases[i].split('-');
            // Split time to hours and minutes
            var startPhase = phase[0].split(':');
            var endPhase = phase[1] ? phase[1].split(':') : '';

            // Create Date object based on currentDate and fill with new data
            var startDate = new Date(this.currentDate.getTime());
            startDate.setHours(startPhase[0]);
            startDate.setMinutes(startPhase[1]);

            var endDate = new Date(this.currentDate.getTime());
            // If start time hour is greater than end time hour (e.g. 16:00-03:00) the end time must be valued as the day after
            if (startPhase[0] > endPhase[0]) {
                endDate.setDate(endDate.getDate() + 1);
            }

            endDate.setHours(endPhase[0]);
            endDate.setMinutes(endPhase[1]);

            // Check if currentDate is between start and end time
            if (startDate <= this.currentDate && endDate > this.currentDate) {
                isStoreOpen = true;
            }
        }

        return isStoreOpen;
    }

    // Function to convert hours and minutes to total minutes
    convertToMinutes (hoursAndMinutes) {
        var hours = hoursAndMinutes[0];
        var minutes = hoursAndMinutes[1];
        return hours * 60 + minutes;
    }

    // Function to convert total minutes to hours and minutes
    convertToHoursAndMinutes (totalMinutes) {
        var hours = Math.floor(totalMinutes / 60);
        var minutes = totalMinutes % 60;
        return [hours, minutes];
    }

    // Function that returns the hours in which the disponibilità allargata shipping will be available considering the closing times
    getDispoArrival (storeHours, store) {
        var _self = this;

        var phases = $(storeHours).data('phases') ? $(storeHours).data('phases').split(' / ') : false;
        var tomorrowFirstPhase = $('[data-store-id="' + store.data('store-id') + '"] li[data-name="' + this.tomorrow + '"]').data('first-phase');
        var currentPhase = -1;
        var isTomorrow = false;

        // Loop through x phases
        for (var i = 0; i < phases.length; i++) {
            var phase = phases[i].split('-'); // Split start and end time
            var startPhase = phase[0].split(':'); // Split hours and mins for

            var startDate = new Date(this.currentDate.getTime()); // Create Date object based on currentDate
            var currentHourArray = [startDate.getHours(), startDate.getMinutes()];
            startDate.setHours(startPhase[0]); // Set hours and mins based on
            startDate.setMinutes(startPhase[1]);

            // Check if today occured a phase
            if (startDate <= this.currentDate) {
                currentPhase = i;
            }
        }
        var endCurrentPhaseArray = currentPhase > -1 ? ((phases[currentPhase].split('-'))[1]).split(':') : false;

        var nextPhase;

        if (this.isStoreOpen(storeHours) && _self.isStoreOpenInThreeHours(phases[currentPhase])) {
            // If store is open returns current phase end time
            nextPhase = phases[currentPhase].split('-')[1];
        } else if (currentPhase < phases.length - 1) {
            // Store closed, show next phase start time if available
            nextPhase = phases[currentPhase + 1].split('-')[0];
        } else if (tomorrowFirstPhase) {
            var tomorrowStartTime = tomorrowFirstPhase.split(':');
            if (phases || (this.currentDate.getHours() >= tomorrowStartTime[0] && this.currentDate.getMinutes() >= tomorrowStartTime[1])) {
                // End of phases show next day start time if available
                nextPhase = tomorrowFirstPhase;
                isTomorrow = true;
            }
        } else {
            // End of phases and closed next day
            nextPhase = false;
        }
        var nextPhaseArray = nextPhase.split(':');
        nextPhaseArray = [parseInt(nextPhaseArray[0]), parseInt(nextPhaseArray[1])];
        var dispoArrivalHour;
        var dispoMinutes;
        // If the store is closed
        if (!endCurrentPhaseArray) {
            dispoMinutes = nextPhaseArray[1] < 10 ? '0' + parseInt(nextPhaseArray[1]) : parseInt(nextPhaseArray[1]);
            dispoArrivalHour = (parseInt(nextPhaseArray[0]) + additionDispoHours) + ':' + dispoMinutes;
        } else {
            endCurrentPhaseArray = [parseInt(endCurrentPhaseArray[0]), parseInt(endCurrentPhaseArray[1])];
            // If the store will not be closed in three hours
            if (parseInt(currentHourArray[0]) + additionDispoHours < endCurrentPhaseArray[0]) {
                dispoMinutes = parseInt(currentHourArray[1]) < 10 ? '0' + parseInt(currentHourArray[1]) : parseInt(currentHourArray[1]);
                dispoArrivalHour = (parseInt(currentHourArray[0]) + additionDispoHours) + ':' + dispoMinutes;
                store.parents('.result').find('.today-bopis').removeClass('hidden');
                store.parents('.result').find('.tomorrow-bopis').remove();
            } else if (isTomorrow) {
                var currentMinutes = _self.convertToMinutes(currentHourArray);
                var endPhaseMinutes = _self.convertToMinutes(endCurrentPhaseArray);
                var nextPhaseMinutes = _self.convertToMinutes(nextPhaseArray);
                var residualMinutes = endPhaseMinutes - currentMinutes;
                nextPhaseMinutes = nextPhaseMinutes + (additionDispoHours * 60) - residualMinutes;
                var newCurrentHourArray = _self.convertToHoursAndMinutes(nextPhaseMinutes);
                newCurrentHourArray[1] = parseInt(newCurrentHourArray[1]) < 10 ? '0' + parseInt(newCurrentHourArray[1]) : parseInt(newCurrentHourArray[1]);
                // nextPhaseArray[0] = parseInt(nextPhaseArray[0]) + additionDispoHours;
                // nextPhaseArray[1] = parseInt(nextPhaseArray[1]) < 10 ? '0' + parseInt(nextPhaseArray[1]) : parseInt(nextPhaseArray[1]);
                dispoArrivalHour = newCurrentHourArray.join(':');
                store.parents('.result').find('.today-bopis').remove();
                store.parents('.result').find('.tomorrow-bopis').removeClass('hidden');
            } else {
                // If the store will be closed in three hours
                // Convert the current time and closing time to total minutes
                var currentMinutes = _self.convertToMinutes(currentHourArray);
                var endPhaseMinutes = _self.convertToMinutes(endCurrentPhaseArray);
                var nextPhaseMinutes = _self.convertToMinutes(nextPhaseArray);
                var residualMinutes = endPhaseMinutes - currentMinutes;
                nextPhaseMinutes = nextPhaseMinutes + (additionDispoHours * 60) - residualMinutes;
                var newCurrentHourArray = _self.convertToHoursAndMinutes(nextPhaseMinutes);
                newCurrentHourArray[1] = parseInt(newCurrentHourArray[1]) < 10 ? '0' + parseInt(newCurrentHourArray[1]) : parseInt(newCurrentHourArray[1]);
                dispoArrivalHour = newCurrentHourArray.join(':');
                store.parents('.result').find('.today-bopis').removeClass('hidden');
                store.parents('.result').find('.tomorrow-bopis').remove();
            }
        }
        dispoArrivalHour = _self.reachNextQuarter(dispoArrivalHour);
        return dispoArrivalHour || false;
    }

    isStoreOpenInThreeHours (currentPhase) {
        var currentPhaseArray = currentPhase.split('-');
        var nowInThreeHourse = new Date();
        nowInThreeHourse.setHours(nowInThreeHourse.getHours() + additionDispoHours);
        var closingHourArray = currentPhaseArray[1].split(':');
        var closingDate = new Date();
        closingDate.setHours(closingHourArray[0]);
        closingDate.setMinutes(closingHourArray[1]);
        return closingDate > nowInThreeHourse;
    }

    reachNextQuarter (dispoArrivalHour) {
        var [hours, minutes] = dispoArrivalHour.split(':').map(Number);
        var totalMinutes = hours * 60 + minutes;
        var roundedMinutes = Math.ceil(totalMinutes / 15) * 15;
        var roundedHours = Math.floor(roundedMinutes / 60);
        var remainingMinutes = roundedMinutes % 60;
        var roundedTime = `${String(roundedHours).padStart(2, '0')}:${String(remainingMinutes).padStart(2, '0')}`;
        return roundedTime;
    }
}

const storeHoursObject = new StoreHours();
export default storeHoursObject;
